import { Component, Input } from '@angular/core';

@Component({
    selector: 'core-block-ai-faq',
    templateUrl: './block-ai-faq.component.html',
    standalone: false,
})
export class BlockAiFaqComponent {
    @Input() faq!: {
        question: string;
        answer: string;
        actionUrl?: string;
    };
}
